@if (!readOnly) {
  <div class="mt-3">
    <label>{{ 'MANAGEMENT.WORKFLOW.RULE-DESTINATION-STEP' | translate }}</label>
    <topo-color-item-select [selectedUId]="selectedStepUId"
      [label]="selectedStatusName"
      [colorCode]="selectedStatusColorCode"
      itemLabel="statusName"
      itemColorCode="statusHtmlColorCode"
      [items]="workflowStepListItems"
      [isXLarge]="true"
      (itemSelected)="stepSelected($event)"
      isActive="isActive">
    </topo-color-item-select>
  </div>
}

@if (readOnly) {
  <div [innerHtml]="action?.displayText | safeHtml"></div>
}
